module.exports = __webpack_public_path__ + "static/img/apple_th.88f270b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/apple_th.png
// module id = XRhy
// module chunks = 0